import { calculatePanelHeight } from "../../util/formulas/calculatePanelHeight";
import { calculatePanelWidth } from "../../util/formulas/calculatePanelWidth";
import { picoWindowEvenSide } from "./StilesRailsAccordian";

function getStilesImage(arg: {
  stiles: string;
  panelErr: { slimline?: string; euro?: string; euroTrad?: string };
  material: string;
  isAccoya: boolean;
  doorType: string;
  evenConfig: boolean | undefined;
  config: string;
  pivotMovement: string;
  width: number;
  height: number;
  exactConfig: string;
  comboWindowConfig: string;
  requireTradLockStile: boolean;
}) {
  const {
    stiles,
    panelErr,
    material,
    isAccoya,
    doorType,
    evenConfig,
    config,
    pivotMovement,
    width,
    height,
    exactConfig,
    comboWindowConfig,
    requireTradLockStile,
  } = arg;

  let dsi = "";
  let dsi2 = "";
  let dsi3 = "";

  if (!stiles) return { dsi, dsi2, dsi3 };

  const isCombo = doorType?.includes("Combo");

  if (stiles.includes("Slimline")) {
    if (panelErr?.slimline) return { dsi: "", dsi2: "", dsi3: "" };

    if (stiles.includes("Traditional")) {
      //Slimline Traditional
      if (material === "All Wood" && doorType && doorType.includes("Window")) {
        dsi = isAccoya ? "accoyaSlimlineTrad" : "woodSlimlineTrad";
      } else {
        dsi = "euro_2-1";
      }

      if (requireTradLockStile) dsi2 = "euroTrad"
    } else {
      //Slimline
      if (material === "All Wood" && doorType && doorType.includes("Window")) {
        dsi = isAccoya ? "accoyaSlimline" : "woodSlimline";
      } else {
        dsi = "slimline-square";
      }

      if (doorType && config === "Fixed Slider") {
        dsi2 = "euro_3-7";
        if (requireTradLockStile) dsi3 = "trad_top";
      } else if (isCombo && !evenConfig) {
        if (requireTradLockStile) {
          dsi2 = "euroTrad";
        } else {
          dsi2 = "euro_3-7";
        }
      } else if (
        doorType &&
        !doorType.includes("Window") &&
        !evenConfig &&
        doorType !== "Fixed Panel"
      ) {
        dsi2 = "euro_3-7";
        if(config === "Fritsjurgens" && pivotMovement === "Free Swing" && requireTradLockStile){
          dsi2 = "euro_3-7"
          dsi3 = "euroTrad"
        }else if (requireTradLockStile){
          dsi2 = "euroTrad"
        } 
      }

      const showwindowlockimg = ["3L", "3R", "5L", "5R"];

      if (
        (isCombo && showwindowlockimg.includes(comboWindowConfig)) ||
        (doorType.includes("Window") && showwindowlockimg.includes(exactConfig))
      ) {
        dsi2 = "euro_3-7";
        if (requireTradLockStile) dsi2 = "euroTrad";
      }
    }
  } else if (stiles.includes("Euro")) {
    if (doorType === "Slider" && width && height) {
      const panelWidth = calculatePanelWidth({
        doorType: "Slider",
        netWidth: width,
        numberOfPanels: 0,
        material,
        exactConfig,
        stilesAndRails: stiles,
        sliderPocket:
          exactConfig.includes("P") && !exactConfig.includes("Primary")
            ? "With Pocket"
            : "No Pocket",
      });

      const panelHeight = calculatePanelHeight({
        exactConfig,
        doorType: "Slider",
        sillStyle: "Raised SILLution",
        netHeight: height,
        screenType: "",
        material,
        isPico: false,
      });

      const approxSqFt = panelWidth
        ? Math.round((panelWidth * panelHeight) / 144)
        : 0;
      if (approxSqFt > 50) {
        if (material === "All Wood") {
          dsi2 = !isAccoya ? "woodTradTop" : "accoyaTradTop";
        } else {
          dsi2 = "euroTrad_v2";
        }
      }
    }

    //Euro
    if (material === "All Wood") {
      dsi = !isAccoya && doorType !== "Pivot" ? "woodEuro_v2" : "accoyaEuro_v2";
    } else {
      dsi = "euroClad";
    }

    if (
      doorType === "Pivot" &&
      config === "Fritsjurgens" &&
      pivotMovement === "Self Closing"
    ) {
      dsi2 =
        material === "All Wood"
          ? "accoyaTradTop"
          : "euroTrad_v2";
    } else if (requireTradLockStile) {
      dsi2 =
        material === "All Wood" && isAccoya
          ? "accoyaTradTop"
          : material === "All Wood"
            ? "woodTradTop"
            : "euroTrad_v2";
    }
  } else if (stiles.includes("Bottom")) {
    //Traditional
    if (material === "All Wood") {
      dsi = !isAccoya && doorType !== "Pivot" ? "woodTradTop" : "accoyaTradTop";
    } else {
      dsi = "trad_top";
    }

    if (stiles.includes("7")) {
      if (material === "All Wood") {
        dsi2 =
          !isAccoya && doorType !== "Pivot" ? "woodTradBtm" : "accoyaTradBtm";
      } else {
        dsi2 = "trad_btm";
      }
    }
  } else if (stiles.includes("Pico")) {
    dsi = "nano_square_v2";
    if (doorType.includes("Corner")) {
      dsi2 = "slimline-square";
      dsi3 = "euro_3-7";
    } else if (doorType.includes("Window") && picoWindowEvenSide(exactConfig)) {
      dsi2 = "";
    } else {
      dsi2 = evenConfig ? "" : "slimline-square";
    }
  }

  return { dsi, dsi2, dsi3 };
}

function getStileImageLabels(
  door: string,
  stiles: string,
  isSlider: boolean,
  pivotHardware: string,
  pivotMovement: string,
  evenConfig: boolean,
  requireTradLockStile: boolean
) {
  let label1 = "";
  let label2 = "";
  let label3 = "";

  if (!stiles) return { label1, label2, label3 };

  if (stiles.includes("Slimline")) {
    if (pivotHardware === "Fritsjurgens" && pivotMovement === "Free Swing") {
      label1 = "Stiles and Bottom Rail";
      if(requireTradLockStile){
        label2 = "Top Rail"
        label3 = "Lock Stile"
      }else{
        label2 = "Lock Stile and Top Rail";
      }
    } else if (isSlider) {
      label1 = "Stiles and Top Rails";
      label2 = "Lock Stile and Bottom Rails";
    } else {
      label1 = "All Stiles and Rails";
      label2 = "Lock Stile";
    }
  } else if (stiles.includes("Euro")) {
    if (pivotHardware === "Fritsjurgens" && pivotMovement === "Self Closing") {
      label1 = "Stiles and Rails";
      label2 = requireTradLockStile ? "Lock Stile and Bottom Rail" : "Bottom Rail";
    } else {
      label1 = "Stiles and Rails";
      label2 = requireTradLockStile ? "Lock Stile" : "Bottom Rail"; //only used for large sliders
    }
  } else if (stiles.includes("Bottom")) {
    label1 = pivotHardware
      ? "Stiles and Top Rail"
      : stiles === 'Bottom rail 4-3/4"'
        ? "Stiles And Rails"
        : "Stiles and Top Rails";
    label2 = pivotHardware ? "Bottom Rail" : "Bottom Rails";
  } else if (stiles.includes("Pico")) {
    if (door.includes("Corner")) {
      label1 = "Stiles and Rails";
      label2 = "Primary Lock Stile";
      label3 = "Secondary Lock Stile";
    } else if (evenConfig) {
      label1 = "Stiles and Rails";
      label2 = "";
    } else {
      label1 = "All Stiles and Rails";
      label2 = "Lock Stile";
    }
  }

  return { label1, label2, label3 };
}

export { getStileImageLabels, getStilesImage };
